// The offer detail route serves two audiences at one URL, so it cannot use the
// plain `manager` middleware.
//
//   /paskyra/mano-pasiulymai/{number}/            the MANAGER's own offer
//   /paskyra/mano-pasiulymai/{number}/?h={hash}   a RECIPIENT's copy of it
//
// The `?h=` form is the link the offer email carries. Any signed-in customer may
// be holding one, so the manager gate must not run for it — whether the hash is
// really theirs is not something the frontend can know, and it is not the
// frontend's call either: `offers/by-hash` answers 404 for a hash addressed to
// somebody else, exactly as it does for one that does not exist.
//
// Without the hash the page is the manager's, and the rule is `manager.ts`'s:
// a logged-in non-manager gets a 404 rather than a redirect, because which offer
// numbers exist is not their business.
//
// Stacks AFTER `auth`, which owns the no-session case.
export default defineNuxtRouteMiddleware((to) => {
  if (to.query.h) return

  const { customer, isLoggedIn } = useCustomerStore()

  if (!isLoggedIn) return

  if (!customer?.is_manager) {
    const { $i18n } = useNuxtApp()
    throw createError({ statusCode: 404, statusMessage: $i18n.t('errors.pageNotFound'), fatal: true })
  }
})
